import React from 'react'

import './styles.scss'
import { SelectWithLabel } from 'components/Form'
import { getStaticImage } from 'utils/statics'
import { lang } from 'utils/helpers'

const InputField = props => {
  const {
    withSearchIcon = true, placeholder, inputValue, selectorValue,
    selectorOptions, onChangeInput, onChangeSelector
  } = props

  return (
    <div className='translations-input-field'>
      {withSearchIcon ? (
        <figure className='translations-input-field__icon'>
          <img src={getStaticImage('/icons/orange-brand/icon-search-grey.svg')} alt='Search' />
        </figure>
      ) : null}
      <input
        className='translations-input-field__input'
        type='text'
        placeholder={placeholder || lang('dashboard_search')}
        value={inputValue || ''}
        onChange={({ target: { value } }) => onChangeInput(value)}
      />
      {inputValue ? (
        <button
          type='button'
          className='translations-input-field__btn'
          onClick={() => onChangeInput('')}
        >
          <figure className='translations-input-field__icon'>
            <img src={getStaticImage('/icons/orange-brand/icon-close-slim-grey.svg')} alt='Clean' />
          </figure>
        </button>
      ) : null}
      {selectorOptions?.length ? (
        <SelectWithLabel
          classNameWrapper='translations-input-field__selector'
          options={selectorOptions}
          value={selectorValue}
          onChange={onChangeSelector}
        />
      ) : null}
    </div>
  )
}

export default InputField
